import React from "react";
import toast, { Toaster } from "react-hot-toast";
import useScreenType from "../hooks/useScreenType";
import useCssProperty from "../hooks/useCssProperty";
import * as Const from "./../_Const";

const ToasterBar = () => {
  const screenType = useScreenType();
  const bgColor = useCssProperty("--color-accent-dark");

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "x":
          css = 75;
          break;
        case "padding":
          css = "12px";
          break;
        case "font":
          css = "16px";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "32px";
          break;
        case "font":
          css = "18px";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "32px";
          break;
        case "font":
          css = "18px";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "x":
          css = 120;
          break;
        case "padding":
          css = "32px";
          break;
        case "font":
          css = "18px";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }
  return (
    <Toaster
      containerStyle={{
        top: getCssFor("x"),
        left: 20,
        bottom: getCssFor("x"),
        right: 20,
      }}
      toastOptions={{
        position: "bottom-center",
        style: {
          borderRadius: "10px",
          background: bgColor,
          color: "#fff",
          padding: getCssFor("padding"),
          fontSize: getCssFor("font"),
        },
      }}
    />
  );
};

export default ToasterBar;
